import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';
const client = axios.create({ baseURL: API_BASE });
client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) { config.headers = config.headers || {}; config.headers.Authorization = `Bearer ${token}`; }
  return config;
});

export async function getNarrativa() {
  const { data } = await client.get('/estrategia/narrativa');
  return data;
}
export async function getPrep(payload) {
  const { data } = await client.post('/estrategia/prep', payload);
  return data;
}
export async function getWarroom() {
  const { data } = await client.get('/estrategia/warroom');
  return data;
}
